import React from "react";
import queryString from "querystring";
import { Route } from "react-router";
import { Redirect } from "react-router";
import { RouteProps } from "react-router";
import { useLocation } from "react-router";
import { RouteComponentProps } from "react-router";
import { useAuth } from "../../hooks/useAuth";
import Loading from "../../../../components/Loading";
import PublicLayout from "../../../app/components/layouts/PublicLayout";

const GuestRoute = ({ component: Component, ...rest }) => {
  const {
    data: { authorizing, isAuthenticated },
  } = useAuth();

  const { hash } = useLocation();

  function renderRoute(routeProps: RouteComponentProps) {
    const { location } = routeProps;
    if (authorizing) {
      return <Loading />;
    }

    let from: any = "/0";
    if (location) {
      let queryParams = queryString.parse(location.search.split("?").join(""));
      from = queryParams.from || "/0";
    }

    if (isAuthenticated) {
      return <Redirect to={from + hash.replace("#", "?")} />;
    }

    return (
      <PublicLayout {...routeProps}>
        <Component {...routeProps} />
      </PublicLayout>
    );
  }

  return <Route render={renderRoute} {...rest} />;
};

export default React.memo(GuestRoute);
